<template>
	<div class="wrap">
		<h1>请填写报名信息</h1>
		<p class="tip">带*为必填内容，在需要填写数字的输入框内，请使用半角数字。</p>
		<p class="line"></p>
		<el-form :model="form" :rules="rules" ref="formRef">
			<el-form-item label="真实姓名" required>
				<span style="margin-right: 10px;">{{ form.name }}</span>
				<el-button
					type="primary"
					@click="
						() => {
							$emit('update:active', 1);
						}
					"
				>
					返回
				</el-button>
			</el-form-item>
			<el-form-item label="身份证号码" prop="card_id">
				<el-input
					@change="
						val => {
							$refs.formRef.validateField('card_id', error => {
								if (!error) {
									$set(form, 'date_birth', $getBirthdayFromIdCard(val));
								}
							});
							$refs.formRef.validateField('gender', error => {
								if (!error) {
									let str = form.card_id, num = str.charAt(16);
									if (num % 2 == 0) {
										$set(form, 'gender', 2);
									} else {
										$set(form, 'gender', 1);
									};
								}
							});
						}
					"
					maxlength="18"
					v-model="form.card_id"
					placeholder="请输入身份证号码"
				></el-input>
			</el-form-item>
			<el-form-item v-if="category_options.length" label="报考类别" prop="category">
				<el-select v-model="form.category" placeholder="请选择岗位类别">
					<el-option v-for="item in category_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="报考单位" prop="department_id">
				<el-select v-model="form.department_id" placeholder="请选择报考单位">
					<el-option v-for="item in department_options" :key="item.department_id" :label="item.department_name" :value="item.department_id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="报考岗位" prop="position_id">
				<el-select v-model="form.position_id" placeholder="请选择报考岗位">
					<el-option v-for="item in position_options" :key="item.position_id" :label="item.position_name" :value="item.position_id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="性别" prop="gender">
				<el-radio-group v-model="form.gender">
					<el-radio :label="1">男</el-radio>
					<el-radio :label="2">女</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="出生年月" prop="date_birth">
				<el-date-picker :picker-options="{ disabledDate }" readonly value-format="yyyy-MM-dd" v-model="form.date_birth" type="date" placeholder="选择日期"></el-date-picker>
			</el-form-item>
			<!-- 详细信息 -->
			<template v-for="(item, index) in form.details">
				<!-- 输入框 -->
				<template v-if="item.type == 1 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'blur' }"
					>
						<el-input v-model="item.value" :maxlength="item.length && item.length !== '0' ? item.length : ''" :placeholder="item.tips"></el-input>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 1 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<el-input v-model="item.value" :maxlength="item.length && item.length !== '0' ? item.length : ''" :placeholder="item.tips"></el-input>
					</el-form-item>
				</template>

				<!-- 文本域 -->
				<template v-if="item.type == 2 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'blur' }"
					>
						<el-input
							type="textarea"
							v-model="item.value"
							resize="none"
							:autosize="{ minRows: 6, maxRows: 6 }"
							:maxlength="item.length && item.length !== '0' ? item.length : ''"
							:placeholder="item.tips"
						></el-input>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 2 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<el-input
							type="textarea"
							v-model="item.value"
							resize="none"
							:autosize="{ minRows: 6, maxRows: 6 }"
							:maxlength="item.length && item.length !== '0' ? item.length : ''"
							:placeholder="item.tips"
						></el-input>
					</el-form-item>
				</template>

				<!-- 选择器 -->
				<template v-if="item.type == 3 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
						<template v-if="item.name === '民族'">
							<el-select v-model="item.value" :placeholder="item.tips">
								<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</template>
						<template v-else>
							<el-select v-model="item.value" clearable :placeholder="item.tips">
								<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</template>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 3 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<template v-if="item.name === '民族'">
							<el-select v-model="item.value" :placeholder="item.tips">
								<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</template>
						<template v-else>
							<el-select v-model="item.value" clearable :placeholder="item.tips">
								<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</template>
					</el-form-item>
				</template>

				<!-- 选择器（多选） -->
				<template v-if="item.type == 4 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
						<template v-if="item.name === '民族'">
							<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
								<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</template>
						<template v-else>
							<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
								<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</template>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 4 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<template v-if="item.name === '民族'">
							<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
								<el-option v-for="item in nation" :key="item.id" :label="item.name" :value="item.name"></el-option>
							</el-select>
						</template>
						<template v-else>
							<el-select v-model="item.value" multiple collapse-tags :placeholder="item.tips">
								<el-option v-for="item in item.box_text.split(',')" :key="item" :label="item" :value="item"></el-option>
							</el-select>
						</template>
					</el-form-item>
				</template>

				<!-- 文件上传 -->
				<template v-if="item.type == 5 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
						<upload-file
							:multiple="true"
							path="certificate"
							:name="item.name"
							@add:files="
								val => {
									item.value.push(val);
									$refs.formRef.validateField('details.' + index + '.value');
								}
							"
							@del:files="
								fileList => {
									item.value = fileList;
									$refs.formRef.validateField('details.' + index + '.value');
								}
							"
						></upload-file>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 5 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<upload-file
							:multiple="true"
							path="certificate"
							:name="item.name"
							@add:files="
								val => {
									item.value.push(val);
									$refs.formRef.validateField('details.' + index + '.value');
								}
							"
							@del:files="
								fileList => {
									item.value = fileList;
									$refs.formRef.validateField('details.' + index + '.value');
								}
							"
						></upload-file>
					</el-form-item>
				</template>

				<!-- 日期选择器 -->
				<template v-if="item.type == 6 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
						<el-date-picker v-model="item.value" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 6 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<el-date-picker v-model="item.value" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
					</el-form-item>
				</template>

				<!-- 日期选择器 -->
				<template v-if="item.type == 8 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
					<el-date-picker v-model="item.value" type="daterange" value-format="yyyy-MM-dd"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 8 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
					<el-date-picker v-model="item.value" type="daterange" value-format="yyyy-MM-dd"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
					</el-form-item>
				</template>

				<!-- 日期选择器 -->
				<template v-if="item.type == 9 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
						<el-date-picker v-model="item.value" value-format="yyyy-MM" type="month" placeholder="选择年月"></el-date-picker>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 9 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
						<el-date-picker v-model="item.value" value-format="yyyy-MM" type="month" placeholder="选择年月"></el-date-picker>
					</el-form-item>
				</template>

				<!-- 日期选择器 -->
				<template v-if="item.type == 10 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'change' }"
					>
					<el-date-picker v-model="item.value" type="monthrange" value-format="yyyy-MM"
						range-separator="至" start-placeholder="开始年月" end-placeholder="结束年月"></el-date-picker>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 10 && item.is_required != 1">
					<el-form-item :label="item.name" :prop="'details.' + index + '.value'">
					<el-date-picker v-model="item.value" type="monthrange" value-format="yyyy-MM"
						range-separator="至" start-placeholder="开始年月" end-placeholder="结束年月"></el-date-picker>
					</el-form-item>
				</template>
				
				<!-- 手机号 -->
				<template v-if="item.type == 7 && item.is_required == 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="[
							{
								validator: validatePhone,
								trigger: 'blur'
							},
							{ required: true, message: item.tips || `${item.name}不能为空`, trigger: 'blur' }
						]"
					>
						<el-input
							v-model="item.value"
							maxlength="11"
							@input="
								() => {
									item.value = item.value.replace(/[^\d]/g, '');
								}
							"
							:placeholder="item.tips"
						></el-input>
					</el-form-item>
				</template>
				<template v-else-if="item.type == 7 && item.is_required != 1">
					<el-form-item
						:label="item.name"
						:prop="'details.' + index + '.value'"
						:rules="{
								validator: validatePhone,
								trigger: 'blur'
							},"
					>
						<el-input
							v-model="item.value"
							maxlength="11"
							@input="
								() => {
									item.value = item.value.replace(/[^\d]/g, '');
								}
							"
							:placeholder="item.tips"
						></el-input>
					</el-form-item>
				</template>
			</template>
		</el-form>
		<div class="footer-btns"><el-button type="primary" @click="onSubmit()">提交报名</el-button></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import UploadFile from '@/components/UploadFile';
import nation from '@/assets/nation.json';
import { MessageBox } from 'element-ui';
import { validateCardID, validatePhone } from '@/tools/validate';
import { getNowFormatDate, GetAge } from '@/tools';
import { reqShowAddCandidate, reqAddCandidate, reqShowPositionType } from '@/api';
export default {
	components: {
		UploadFile
	},
	data() {
		return {
			nation,
			validatePhone,
			inser: true,
			// 默认信息表单
			form: {
				gender: 1,
				category: '',
				details: []
			},
			rules: {
				gender: [
					{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}
				],
				card_id: [
					{
						validator: validateCardID,
						trigger: 'blur'
					},
					{
						required: true,
						message: '请输入身份证号码',
						trigger: 'blur'
					}
				],
				date_birth: [
					{
						required: true,
						message: '请选择出生年月',
						trigger: 'change'
					}
				],
				category: [
					{
						required: true,
						message: '请选择报考类别',
						trigger: 'change'
					}
				],
				department_id: [
					{
						required: true,
						message: '请选择报考单位',
						trigger: 'change'
					}
				],
				position_id: [
					{
						required: true,
						message: '请选择报考岗位',
						trigger: 'change'
					}
				]
			},
			// 部门列表
			department_options: [],
			// 岗位列表
			position_options: [],
			// 岗位类别列表
			category_options: []
		};
	},
	computed: {
		...mapState({
			examination_id: state => state.system.examInfo.examination_id,
			regist_end_time: state => state.system.examInfo.regist_end_time,
			company_id: state => state.system.company_id
		})
	},
	watch: {
		'form.department_id': {
			handler(val) {
				if (this.form.position_id) {
					this.form = {
						...this.form,
						position_id: ''
					};
				}
				if (val) {
					this.getPosition();
				}
			}
		},
		'form.category': {
			handler(val) {
				if (this.form.department_id) {
					this.form = {
						...this.form,
						department_id: ''
					};
				}
				this.getShowDatas();
			}
		},
		'form.card_id': {
			handler(val) {
				if (this.form.card_id) {
					sessionStorage.setItem('path', `${this.form.name}${this.form.card_id}`);
				}
			}
		},
	},
	mounted() {
		this.$bus.$on('update:name', (name, autograph) => {
			this.form = {
				...this.form,
				name,
				autograph
			};
		});
		this.getTypeList();
		this.getShowDatas();
	},
	beforeDestroy() {
		this.$bus.$off('update:name');
	},
	methods: {
		// 获取回显信息(表单、部门)
		getShowDatas() {
			reqShowAddCandidate({
				company_id: this.company_id,
				category: this.form.category,
				examination_id: this.examination_id
			}).then(res => {
				this.department_options = res.data.department;
				this.form.details = res.data.form.map(v => {
					return {
						...v,
						value: v.type === 4 || v.type === 5 ? [] : ''
					};
				});
			});
		},
		// 获取岗位
		getPosition() {
			reqShowAddCandidate({
				company_id: this.company_id,
				examination_id: this.examination_id,
				category: this.form.category,
				department_id: this.form.department_id
			}).then(res => {
				this.position_options = res.data;
			});
		},
		// 获取岗位类别列表
		getTypeList() {
			reqShowPositionType({
				company_id: this.company_id
			}).then(res => {
				this.category_options = res.data;
			});
		},
		// 提交报名
		onSubmit() {
				this.$refs['formRef'].validate(valid => {
					if(!this.inser) {
						this.$message({type: 'info', message: '正在提交！！' });
						return false;
					}
					let msgCtr = true;
					/*
					//针对岗位验证表单内容
					let positionId = new Set([1,2,3]);
					if(positionId.has(this.form.position_id)) {
						this.form.details.forEach( obj => {
							if (obj.name==="健康状况" && !obj.value) {
								this.msg = "报考什么岗位，健康状况不能为空";
								msgCtr = false;
								MessageBox.alert(this.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
								this.$message({
									type: 'info',
									message: `action: ${ action }`
								});
							  }
							});
							}
							if (obj.name==="毕业证书" && obj.value.length===0) {
								this.msg = "报考什么岗位，需要上传毕业证书";
								msgCtr = false;
								MessageBox.alert(this.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
								this.$message({
									type: 'info',
									message: `action: ${ action }`
								});
							  }
							});
							}
							if (obj.name==="学位证书" && obj.value.length===0) {
								this.msg = "报考什么岗位，需要上传学位证书";
								msgCtr = false;
								MessageBox.alert(this.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
								this.$message({
									type: 'info',
									message: `action: ${ action }`
								});
							  }
							});
							}
						});
					}
					*/
					/*
					//前端针对验证表单内容
					let ctr = false;
					this.form.details.forEach( obj => {
						if (obj.name==="测试表单" && obj.value=="测试表单值") {
							ctr = true;
						}
						if (ctr) {
							if (obj.name==="健康状况" && !obj.value) {
								this.msg = "测试表单的值为“测试表单值”，健康状况不能为空";
								msgCtr = false;
								MessageBox.alert(this.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
								this.$message({
									type: 'info',
									message: `action: ${ action }`
								});
							  }
							});
							}
							if (obj.name==="毕业证书" && obj.value.length===0) {
								this.msg = "测试表单的值为“测试表单值”，需要上传毕业证书";
								msgCtr = false;
								MessageBox.alert(this.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
								this.$message({
									type: 'info',
									message: `action: ${ action }`
								});
							  }
							});
							}
							if (obj.name==="学位证书" && obj.value.length===0) {
								this.msg = "测试表单的值为“测试表单值”，需要上传学位证书";
								msgCtr = false;
								MessageBox.alert(this.msg, '提示', {
								confirmButtonText: '确定',
								callback: action => {
								this.$message({
									type: 'info',
									message: `action: ${ action }`
								});
							  }
							});
							}
						}
					});
					*/
					MessageBox.confirm('<strong style="color: #409EFF; font-size: 28px">姓名：' + this.form.name + '</strong></br>' 
						+ '<strong style="color: #409EFF; font-size: 28px">身份证号:</br>' + this.form.card_id + '</strong>', '请确认姓名及身份证号是否填写正确', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true
					}).then(() => {
						if (valid && this.inser && msgCtr) {
							this.inser = false;
							reqAddCandidate({
								...this.form,
								company_id: this.company_id,
								examination_id: this.examination_id,
								age: this.position_options.filter(v => v.position_id === this.form.position_id)[0].age
							}).then(res => {
								this.$message.success(res.msg);
								this.$store.commit('user/SET_NAME', this.form.name);
								this.$store.commit('user/SET_ID', res.data.id);
								this.$store.commit('user/SET_SERIAL_ID', res.data.serial_id);
								this.$store.commit('system/SET_PAY_MENT', res.data.payment);
								this.$store.commit('user/SET_TOTAL', []);
								let time_out = new Date().getTime()/1000 + 60 * 15;
								this.$store.commit('system/SET_TIME_OUT', time_out);
								let _this = this;
								setTimeout(() => {
									_this.$store.dispatch('user/resetUserInfo');
								},1000);
								MessageBox.alert('<strong style="color: #F56C6C; font-size: 24px">请记住报名序号：' + res.data.serial_id + '，再上传本人正面清晰证件照，避免影响审核结果！！！</strong>', '温馨提示', {
									confirmButtonText: '确定',
									showClose: false,
									dangerouslyUseHTMLString: true,
									beforeClose: (action, instance, done) => {
										if (action === 'confirm') {
											instance.confirmButtonLoading = true;
											instance.confirmButtonText = '执行中...';
											setTimeout(() => {
												done();
												setTimeout(() => {
													instance.confirmButtonLoading = false;
												}, 300);
											}, 3000);
										} else {
											done();
										}
									},
									callback: action => {
									}
								});
							}).catch((error => {
								this.inser = true;
								console.log(error);
							}));
						} else {
							return false;
						}
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '请重新填写'
						});          
					});
				});
		},
		disabledDate(date) {
			return new Date().getTime() < new Date(date).getTime();
		}
	}
};
</script>

<style lang="scss" scoped>
.wrap {
	h1 {
		font-size: 20px;
		font-weight: bold;
		color: #000;
		text-align: center;
	}

	.tip {
		font-size: 16px;
		color: #ff070a;
		text-align: center;
	}

	.line {
		border: 1px solid #e5e5e5;
		margin: 12px 0;
	}
	

	.el-form {
		width: 600px;
		margin: 0 auto;
		padding-right: 10px;
		.el-form-item__label {
			text-align:left;
		}
		.el-select,
		.el-date-editor {
			width: 100%;
		}
	}
}
</style>
